import styled from 'styled-components';

export const Row = styled.div`
    width: 100%;
    padding: 4px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const Column = styled.div`
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin || 0};
    display: flex;
    flex-direction: column;
    
      @media screen and (max-width: 600px) {
        margin: ${({mobileMargin}) => mobileMargin || 0}
      }
`;
